import { IBuilder, Builder } from 'builder-pattern';

export interface ForumPaginationInterface {
  limit: number;
  offset: number;
}

export interface ForumPaginatedResponseInterface<T> {
  data: T[];
  total: number;
  pagination: ForumPaginationInterface;
}

export namespace ForumPaginationInterface {
  export function builder(
    template?: Partial<ForumPaginationInterface>
  ): IBuilder<ForumPaginationInterface> {
    return Builder<ForumPaginationInterface>(template);
  }
}